export default __webpack_public_path__ + "static/media/Twitter-big.2b71be28.svg";